class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if( !this.classList.contains('collection_top_filter_info') ){
      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const facetButton = this.querySelector(".facets__open-button");
    if (facetButton) {
			facetButton.onclick = () => {
        this.querySelector(".facets__wrapper").classList.add("active");
        this.closest(".collection-wrapper")
				.querySelector(".products-grid__overlay")
				.classList.add("active");
			document.body.classList.add("overflow-hidden");
      }
    }

    if( this.closest(".collection-wrapper") ){
      const overlay = this.closest(".collection-wrapper").querySelector(".products-grid__overlay");
      if (overlay)
      overlay.onclick = (event) => {
        event.currentTarget.closest(".collection-wrapper").querySelector(".facets__wrapper").classList.remove("active");
        event.currentTarget.classList.remove('active');
        document.body.classList.remove("overflow-hidden");
      }
    }

    const facetsClose = this.querySelector(".facets__close");
    if (facetsClose) {
      facetsClose.onclick = () => {
        this.querySelector(".facets__wrapper").classList.remove("active");
        this.closest(".collection-wrapper")
          .querySelector(".products-grid__overlay")
          .classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      };
    }

    const active_facets_el = document.querySelectorAll('.active-facets');
    active_facets_el.forEach((el)=>{
      const remove_facets_els = el.querySelectorAll('facet-remove.active-facets__button');
      remove_facets_els.length>0 && (
        el.querySelectorAll('facet-remove.active-facets__button')[remove_facets_els.length - 1].classList.add('last')
      );
    })
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    let winPath = window.location.pathname;
    let type = ''
    if( document.querySelector('.search-result.search-performed') ){
      winPath = '/search';
      type = '&type=product'
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    // -----------------------------------------------------------------------
    // BUGFIX (dragging multiple range sliders loses earlier edits):
    //
    // Each filter commit (slider release, typed value, checkbox, etc.) calls
    // renderPage(), which fires an independent fetch. There was no ordering
    // guarantee between these fetches -- if you drag Length, then Width, then
    // Height in quick succession, you can have three requests in flight at
    // once, and whichever RESPONSE happens to arrive last "wins" and gets
    // painted onto the page, even if it was actually the OLDEST request
    // (reflecting only Length, or only Length+Width). That silently discards
    // later edits. Typing is naturally slower (seconds between fields), so
    // requests rarely overlapped there, which is why the symptom showed up
    // for dragging but not typing.
    //
    // Fix: stamp every renderPage() call with an incrementing sequence
    // number, and drop any response that comes back once a newer request has
    // already been dispatched.
    // -----------------------------------------------------------------------
    const seq = ++FacetFiltersForm.requestSeq;

    sections.forEach((section) => {
      const url = `${winPath}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, seq) :
        FacetFiltersForm.renderSectionFromFetch(url+type, event, seq);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, seq) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        // A newer request has been dispatched since this one -- this
        // response is stale, ignore it so it can't overwrite newer state.
        if (seq !== FacetFiltersForm.requestSeq) return;

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, seq) {
    if (seq !== FacetFiltersForm.requestSeq) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) {
      loadMore();
    }

    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML || '0 results';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.querySelector('.mobile-facets__count');
    container && (
      container.innerHTML = count,
      container.classList.remove('loading')
    );
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
    }

    // Parse the numeric count and show/hide the zero-results warning
    const countText = container ? container.textContent : '';
    const countNum = parseInt(countText.replace(/[^0-9]/g, ''), 10);
    FacetFiltersForm.toggleZeroResultsWarning(isNaN(countNum) ? false : countNum === 0);
  }

  static toggleZeroResultsWarning(show) {
    const WARNING_ID = 'facets-zero-results-warning';
    const bottom = document.querySelector('.facets__wrapper-bottom');
    if (!bottom) return;

    let warning = document.getElementById(WARNING_ID);

    if (show) {
      if (!warning) {
        warning = document.createElement('p');
        warning.id = WARNING_ID;
        warning.textContent = 'No results. Adjust your selection.';
        warning.style.cssText = [
          'margin: 0 auto 0 0',
          'padding: 0 20px',
          'height: 56px',
          'background: #FBCB00',
          'border: none',
          'border-radius: 999px',
          'font-size: 13px',
          'color: rgb(var(--color-foreground))',
          'line-height: 1',
          'text-align: left',
          'display: inline-flex',
          'align-items: center',
          'flex-shrink: 0'
        ].join(';');
        bottom.insertBefore(warning, bottom.firstChild);
      }
    } else {
      if (warning) warning.remove();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const el_html = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if( el_html ){
        el_html.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__open-button")) {
        document.querySelector(".facets__open-button").classList.add('facets__open-button_accent');
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__open-button")) {
        document.querySelector(".facets__open-button").classList.remove('facets__open-button_accent');
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--tertiary")) {
        document.querySelector(".facets__wrapper-bottom .button--tertiary").removeAttribute('disabled');
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--tertiary")) {
        document.querySelector(".facets__wrapper-bottom .button--tertiary").setAttribute('disabled', '');
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.removeAttribute('disabled');
        })
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.setAttribute('disabled', '');
        })
      }

      const p_ele_custom = activeFacetsElement.closest('facet-filters-form');
      if( p_ele_custom && p_ele_custom.classList.contains('collection_top_filter_info') ){
        if( !p_ele_custom.classList.contains('no-facets_active') ){
          document.querySelector(selector).closest('facet-filters-form')?.classList.remove('no-facets_active');
        }else{
          document.querySelector(selector).closest('facet-filters-form')?.classList.add('no-facets_active');
        }
      }
    })

    const active_facets_el = document.querySelectorAll('.active-facets');
    active_facets_el.forEach((el)=>{
      const remove_facets_els = el.querySelectorAll('facet-remove.active-facets__button');
      remove_facets_els.length>0 && (
        el.querySelectorAll('facet-remove.active-facets__button')[remove_facets_els.length - 1].classList.add('last')
      );
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      if( document.querySelector(selector) ){
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    if( event.target.closest('.custom-cms-banner-section') ) return;
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if( event.target.closest('.custom-cms-banner-section') ) return;
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      searchParams = this.returnSearchParam(searchParams);
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      var check_data_URL = forms.join('&')
      check_data_URL = this.returnSearchParam(check_data_URL);
      this.onSubmitForm(check_data_URL, event)
    }
  }

  returnSearchParam(queryString){
    if (queryString.includes('%2C')) {
      const queryParts = queryString.split('&');
      const updatedParts = queryParts.map(part => {
        if (part.includes('dimensions') && part.includes('%2C')) {
          let [key, val] = part.split('=');
          const cleanVal = val.replaceAll('%2C',',');
          return `${key}=${cleanVal}`;
        }
        return part;
      });
      return updatedParts.join('&');
    }else{
      return queryString;
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.requestSeq = 0;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    if(this.tagName == 'PRICE-RANGE'){
      this.controlTextInputs();
    }
    this.setInputWidth();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    if(this.tagName == 'CUSTOM-FILTER-RANGE'){
      return;
    }
    const inputs = this.querySelectorAll('input.field__input:not(.hidden_input)');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    // FIX 4: Inject focus-ring and cursor styles once per page for the
    // dimension filter number inputs. Uses theme CSS vars so it matches
    // the rest of the UI automatically.
    if (!document.getElementById('custom-filter-range-styles')) {
      const style = document.createElement('style');
      style.id = 'custom-filter-range-styles';
      style.textContent = `
        custom-filter-range .field-wrapper .field__input:not(.field__input-hidden) {
          cursor: text;
          background: transparent;
          border-bottom: 1px solid rgb(var(--color-border));
          padding-bottom: 1px;
        }
        custom-filter-range .field-wrapper .field__input:not(.field__input-hidden):focus {
          outline: 1px solid rgb(var(--color-border));
          outline-offset: 8px;
          border-radius: 888px;
          border-bottom: none;
          padding-bottom: 1px;
        }
      `;
      document.head.appendChild(style);
    }

    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('input.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('input.field__input')[1];

      // -----------------------------------------------------------------------
      // BUGFIX (dimension sliders applying only one handle):
      //
      // CUSTOM-FILTER-RANGE widgets (Length/Width/Height) have their own
      // dedicated submit pipeline in CustomFilterRange.controlInput(), fired
      // off the 'change' event with a 150ms debounce that correctly combines
      // both handles' values. Native range inputs also fire continuous
      // 'input' events while dragging, which bubble up to the generic
      // FacetFiltersForm form-level listener (500ms debounce, plain
      // FormData snapshot). That generic listener has no knowledge of the
      // in-progress combined min+max calculation, so if it fires after one
      // handle's drag but before the other's dedicated submit finishes, it
      // can silently overwrite the correct combined filter value with a
      // stale, one-sided one -- which is why moving both handles could
      // produce a broken range (e.g. min applied, max reset to default)
      // even though the displayed numbers looked correct.
      //
      // We stop these 'input' events from bubbling out of CUSTOM-FILTER-RANGE
      // elements only. Plain PRICE-RANGE has no dedicated submit path of its
      // own -- it relies entirely on the generic form-level listener -- so we
      // must not stop propagation there.
      // -----------------------------------------------------------------------
      inputRangeFrom.oninput = (e) => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if(this.tagName == 'CUSTOM-FILTER-RANGE'){
          e.stopPropagation();
          // The slider runs in WHOLE-INCH integer space (min=floor(smallest),
          // max=floor(largest), step=1), so every whole inch between the axis
          // min and max is a discrete stop -- even inches for which no product
          // exists. `from`/`to` are therefore already whole inches; display
          // them verbatim. controlInput() expands the chosen inch(es) into the
          // real catalog values that exist within the bucket at submit time.
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = to;
          } else {
            inputNumberFrom.value = from;
          }
        }else {
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = to;
          } else {
            inputNumberFrom.value = from;
          }
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = (e) => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if(this.tagName == 'CUSTOM-FILTER-RANGE'){
          e.stopPropagation();
          // Whole-inch integer slider: `from`/`to` are already whole inches,
          // display them directly (see the inputRangeFrom.oninput note above).
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = to;
          } else {
            inputNumberTo.value = from;
            inputRangeTo.value = from;
          }
        }else {
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = to;
          } else {
            inputNumberTo.value = from;
            inputRangeTo.value = from;
          }
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlTextInputs() {
    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('input.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      if (this.tagName == 'CUSTOM-FILTER-RANGE') {

        // Move the slider to reflect the typed value, but leave the number
        // display exactly as the user typed it -- no snapping the text.
        // The slider is in whole-inch integer space, so the thumb position for
        // a typed value is just that value clamped to the axis' inch range.
        const snapFrom = () => {
          const raw = parseFloat(inputNumberFrom.value);
          if (isNaN(raw)) return;
          inputRangeFrom.value = this.clampWhole(raw);
          this.fillSlider();
        };

        const snapTo = () => {
          const raw = parseFloat(inputNumberTo.value);
          if (isNaN(raw)) return;
          inputRangeTo.value = this.clampWhole(raw);
          this.fillSlider();
        };

        // Debounced submit helpers
        let _fromTimer, _toTimer;
        const submitFrom = () => {
          snapFrom();
          this.onRangeChange({ currentTarget: inputRangeFrom });
        };
        const submitTo = () => {
          snapTo();
          this.onRangeChange({ currentTarget: inputRangeTo });
        };

        // Live slider update while typing, submit after 600ms pause
        inputNumberFrom.oninput = () => {
          clearTimeout(_fromTimer);
          const v = parseFloat(inputNumberFrom.value);
          if (!isNaN(v)) { inputRangeFrom.value = this.clampWhole(v); this.fillSlider(); }
          _fromTimer = setTimeout(submitFrom, 600);
        };

        inputNumberTo.oninput = () => {
          clearTimeout(_toTimer);
          const v = parseFloat(inputNumberTo.value);
          if (!isNaN(v)) { inputRangeTo.value = this.clampWhole(v); this.fillSlider(); }
          _toTimer = setTimeout(submitTo, 600);
        };

        // Enter: submit immediately
        inputNumberFrom.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); clearTimeout(_fromTimer); submitFrom(); }
        });
        inputNumberTo.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); clearTimeout(_toTimer); submitTo(); }
        });

        // Blur: submit if anything was typed; restore previous value if empty
        inputNumberFrom.addEventListener('blur', () => {
          clearTimeout(_fromTimer);
          if (inputNumberFrom.value === '') {
            // Nothing typed -- restore the pre-focus value, or fall back to the
            // whole inch the slider currently sits on.
            inputNumberFrom.value = inputNumberFrom.dataset.prefocus || parseInt(inputRangeFrom.value, 10);
            snapFrom();
          } else {
            submitFrom();
          }
        });
        inputNumberTo.addEventListener('blur', () => {
          clearTimeout(_toTimer);
          if (inputNumberTo.value === '') {
            inputNumberTo.value = inputNumberTo.dataset.prefocus || parseInt(inputRangeTo.value, 10);
            snapTo();
          } else {
            submitTo();
          }
        });

        // Focus + mousedown: clear the field so the user types fresh.
        // mousedown fires before focus on a click, and on type="number" the
        // browser can visually restore the value between the two events.
        // Clearing on both events ensures the field is empty when the user
        // starts typing regardless of whether they clicked or tabbed in.
        const clearInput = (inp) => {
          if (inp.dataset.prefocus === undefined || inp.dataset.prefocus === '') {
            inp.dataset.prefocus = inp.value;
          }
          inp.value = '';
        };
        inputNumberFrom.addEventListener('focus', () => clearInput(inputNumberFrom));
        inputNumberFrom.addEventListener('mousedown', (e) => {
          // Only clear on mousedown if not already focused
          if (document.activeElement !== inputNumberFrom) {
            clearInput(inputNumberFrom);
          }
        });
        inputNumberTo.addEventListener('focus', () => clearInput(inputNumberTo));
        inputNumberTo.addEventListener('mousedown', (e) => {
          if (document.activeElement !== inputNumberTo) {
            clearInput(inputNumberTo);
          }
        });

        // Restore saved value if user focused but typed nothing (empty on blur)
        // -- handled above in the blur listeners via the empty-string check.

      } else {
        // Standard price range: original oninput behaviour unchanged.
        inputNumberFrom.oninput = () => {
          const from = parseInt(inputNumberFrom.value, 10);
          const to = parseInt(inputNumberTo.value, 10);
          if (from > to) {
            inputRangeFrom.value = to;
            inputNumberFrom.value = to;
          } else {
            inputRangeFrom.value = from;
          }
          this.fillSlider();
          this.setInputWidth();
        };

        inputNumberTo.oninput = () => {
          const from = parseInt(inputNumberFrom.value, 10);
          const to = parseInt(inputNumberTo.value, 10);
          if (from <= to) {
            inputRangeTo.value = to;
            inputNumberTo.value = to;
          } else {
            inputNumberTo.value = from;
          }
          this.fillSlider();
        };
      }

    })
  }

  setInputWidth() {
    const field_wrapper = document.querySelectorAll('price-range .facets__price-wrapper .field-wrapper');
    field_wrapper.forEach((field_ele)=>{
      const value = field_ele.querySelector('input.field__input').value,
      hidden_ele = field_ele.querySelector('.field__input-hidden');
      let width = 0;
      if( hidden_ele ){
        value != '' && hidden_ele && ( field_ele.querySelector('.field__input-hidden').textContent = value);
        width = field_ele.querySelector('.field__input-hidden').offsetWidth
      }
      field_ele.querySelector('input.field__input').style.minWidth = '';
      width > 33 && (field_ele.querySelector('input.field__input').style.minWidth = width +'px');
      if( field_ele.querySelector('.field__currency') ){
        field_ele.querySelector('.field__currency').classList.remove('no-value');
        value == '' && ( field_ele.querySelector('.field__currency').classList.add('no-value'));
      }
    })
  }

  nearestIndex(arr, value) {
    const found_index = arr.indexOf(value);
    if( found_index > -1 ){
      return found_index;
    }else{
      return arr.reduce((closestIdx, curr, idx) =>
        Math.abs(curr - value) < Math.abs(arr[closestIdx] - value) ? idx : closestIdx
      , 0);
    }
  }

  // -------------------------------------------------------------------------
  // Whole-inch slider helpers (used by CustomFilterRange only).
  //
  // The dimension sliders run in WHOLE-INCH integer space: min = floor of the
  // smallest catalog value, max = floor of the largest, step = 1. Every whole
  // inch between the two is therefore a discrete, selectable stop -- including
  // inches for which no product exists (the backend simply returns nothing for
  // those, which is expected). The catalog values themselves only matter at
  // submit time, where controlInput() expands the chosen inch(es) into the
  // real values that fall inside the bucket.
  // -------------------------------------------------------------------------
  wholeInchLo() {
    if (!this.allowed || this.allowed.length === 0) return 0;
    return Math.floor(this.allowed[0]);
  }

  wholeInchHi() {
    if (!this.allowed || this.allowed.length === 0) return 0;
    return Math.floor(this.allowed[this.allowed.length - 1]);
  }

  // Clamp an arbitrary number to a whole inch within [lo, hi].
  clampWhole(value) {
    const lo = this.wholeInchLo();
    const hi = this.wholeInchHi();
    return Math.min(Math.max(Math.round(value), lo), hi);
  }
}

customElements.define('price-range', PriceRange);

class CustomFilterRange extends PriceRange {
  constructor() {
    super();

    // Re-bind change listeners (super() binds them too, but we need our overridden onRangeChange)
    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    // Build the sorted array of allowed real-world dimension values from the data-values attribute
    this.allowed = (this.querySelector('.facets__custom-range-wrapper').dataset.values || '')
    .replace(/^\[/,'').replace(/\]$/,'')
    .split(',')
    .map(function(s) { return Number(s.trim()); })
    .filter(function(n) { return !isNaN(n); })
    .sort(function(a,b){return a-b;});

    const inputRangeWrappers = this.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = this.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('input.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('input.field__input')[1];

      // -----------------------------------------------------------------------
      // WHOLE-INCH integer slider scale.
      //
      // The Liquid template renders range inputs with max = number of catalog
      // entries. We override both handles to run over whole inches -- from the
      // floor of the smallest catalog value to the floor of the largest, in
      // steps of 1 -- so EVERY whole inch in that span is an individually
      // selectable stop, including inches no product happens to have. The
      // number boxes therefore only ever show whole integers, and controlInput()
      // maps a chosen inch back to the real catalog values in its bucket.
      // -----------------------------------------------------------------------
      const wLo = this.wholeInchLo();
      const wHi = this.wholeInchHi();
      inputRangeFrom.min = wLo;
      inputRangeFrom.max = wHi;
      inputRangeFrom.step = 1;
      inputRangeTo.min = wLo;
      inputRangeTo.max = wHi;
      inputRangeTo.step = 1;

      // Default whole-inch selection: full span.
      let startWholeMin = wLo;
      let startWholeMax = wHi;

      // Seed from the Liquid-rendered number boxes if present.
      const liquidMin = parseFloat(inputNumberFrom.value);
      const liquidMax = parseFloat(inputNumberTo.value);
      if (!isNaN(liquidMin)) startWholeMin = this.clampWhole(liquidMin);
      if (!isNaN(liquidMax)) startWholeMax = this.clampWhole(liquidMax);

      // Restore the whole-inch selection from the current URL after a
      // re-render. The URL param holds the expanded bucket (fractional catalog
      // values), so we recover the whole inches that produced it:
      //   - min inch: the lower bucket edge is (minInch - 0.5), so a chosen
      //     value with a >= .5 fraction was pulled in by the inch above its
      //     floor -> Math.round recovers it. If the smallest chosen value is
      //     the axis minimum, the user was at the bottom stop -> wLo.
      //   - max inch: the upper bucket edge is (maxInch + 1.0) exclusive, so
      //     the largest chosen value's floor is the selected inch. If it is the
      //     axis maximum, the user was at the top stop -> wHi.
      // Overlap-only buckets are inherently ambiguous; the guard below keeps
      // the result well-ordered.
      const paramName = this.dataset.name;
      if (paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        const activeValues = urlParams.get(paramName);
        if (activeValues && this.allowed.length > 0) {
          const parts = activeValues.split(',').map(Number).filter(n => !isNaN(n)).sort((a,b) => a-b);
          if (parts.length > 0) {
            const pMin = parts[0];
            const pMax = parts[parts.length - 1];
            startWholeMin = (pMin <= this.allowed[0]) ? wLo : this.clampWhole(Math.round(pMin));
            startWholeMax = (pMax >= this.allowed[this.allowed.length - 1]) ? wHi : this.clampWhole(Math.floor(pMax));
          }
        }
      }

      if (startWholeMin > startWholeMax) startWholeMin = startWholeMax;

      inputRangeFrom.value  = startWholeMin;
      inputRangeTo.value    = startWholeMax;
      inputNumberFrom.value = startWholeMin;
      inputNumberTo.value   = startWholeMax;

      this.fillSlider();
    });

    // Now that this.allowed is built and tagName is correct, wire up the
    // text input handlers (focus-clear, debounced submit, blur-snap, Enter).
    this.controlTextInputs();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setValue(event.currentTarget);
    this.setMinAndMaxValues();
    this.controlInput(event);
  }

  setValue(input) {
    this.fillSlider();
  }

  controlInput(event) {
    if(this.allowed == undefined || this.allowed.length == 0) return;

    var minSlider = this.querySelector('.lengthMin');
    var maxSlider = this.querySelector('.lengthMax');
    var paramName = this.dataset.name;

    var iMin = Number(minSlider.value);
    var iMax = Number(maxSlider.value);

    // -----------------------------------------------------------------------
    // FIX 2: Prevent mid-drag re-renders ("drunk slider" behavior).
    //
    // The original code called onSubmitHandler immediately (inside a 150ms
    // setTimeout) on every oninput event. The browser fires oninput
    // continuously while the user is dragging, so each tick triggered a full
    // page fetch + DOM rebuild that re-initialized this component under the
    // user's hand, causing the slider to reset or jump.
    //
    // The fix has two parts:
    //   a) We only reach this method via onRangeChange, which is bound to the
    //      'change' event (fires ONCE when the user releases the slider),
    //      not 'input' (fires on every pixel of movement). The controlSlider()
    //      oninput handlers in PriceRange still update the number display
    //      live while dragging -- that visual feedback is preserved.
    //   b) We debounce the actual submit call so rapid successive changes
    //      (e.g. typing in the text input) still coalesce into one request.
    //
    //   c) (see controlSlider() above) the drag 'input' events are also now
    //      stopped from bubbling to the generic FacetFiltersForm listener,
    //      so that listener's own independent debounce can no longer race
    //      with -- and overwrite -- the combined value computed here.
    // -----------------------------------------------------------------------
    if (this._submitTimer) clearTimeout(this._submitTimer);
    this._submitTimer = setTimeout(() => {
      // ---------------------------------------------------------------------
      // WHOLE-INCH BUCKET EXPANSION.
      //
      // The number boxes hold WHOLE inches -- set either by the user typing,
      // or by the drag handlers directly from the whole-inch slider position
      // (see controlSlider). Those boxes are the single source of truth for the
      // selection, which is exactly why dragging until a box reads "20" and
      // typing "20" behave identically: both paths arrive here with the box
      // reading 20.
      //
      // A whole-inch selection is expanded into the exact fractional catalog
      // values that Shopify's list-type metafield filter must receive (the
      // filter is exact-match, so it can only ever match real catalog values,
      // never a bare "20"). Per the store's bucket rule, selecting whole inch
      // N includes every catalog value from N-0.5 up to -- but not including
      // -- N+1.0:
      //     select 20  ->  19.5 .. 20.9
      //     select 21  ->  20.5 .. 21.9
      // The .5-.9 overlap means e.g. 20.7 is offered under both 20 and 21.
      // For a range [minWhole, maxWhole] the union of the per-inch buckets is
      // simply [minWhole-0.5, maxWhole+1.0).
      // ---------------------------------------------------------------------
      const numberInputs = this.querySelectorAll('.facets__price-wrapper input.field__input:not(.hidden_input)');
      let minWhole = parseInt(numberInputs[0] && numberInputs[0].value, 10);
      let maxWhole = parseInt(numberInputs[1] && numberInputs[1].value, 10);

      // Fall back to the slider position if a box is somehow empty/NaN. The
      // slider is in whole-inch space, so iMin/iMax are already whole inches.
      if (isNaN(minWhole)) minWhole = iMin;
      if (isNaN(maxWhole)) maxWhole = iMax;
      if (minWhole > maxWhole) { const t = minWhole; minWhole = maxWhole; maxWhole = t; }

      const lowerBound = minWhole - 0.5;   // inclusive
      const upperBound = maxWhole + 1.0;   // exclusive
      var chosen = this.allowed.filter(v => v >= lowerBound && v < upperBound);

      var url = new URL(window.location.href);
      url.searchParams.delete(paramName);

      this.querySelector(`input.hidden_input[name="${paramName}"]`).value = chosen.join(',');

      this.closest('facet-filters-form').onSubmitHandler(event);
    }, 150);
  }
}
customElements.define('custom-filter-range', CustomFilterRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    if( this.closest('.custom-cms-banner-section') ){
      this.closest('facet-filters-form').querySelectorAll('form').forEach(( form_el )=> form_el.reset());
      this.closest('facet-filters-form').querySelectorAll('custom-filter-range').forEach(( form_el )=>{
        form_el.fillSlider()
        form_el.querySelector('.hidden_input').value = ''
      })
    }else{
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);



class customDropdown extends HTMLElement {
  constructor() {
    super();
    const dropdown = this;
    this.querySelector('.fa--cu-dd__label') && (
      this.querySelector('.fa--cu-dd__label').addEventListener('click', function(){
        if( dropdown.classList.contains('active') ){
          dropdown.classList.remove('active');
        }else{
          dropdown.classList.add('active');
        }
      })
    )

    this.querySelector('.mob-fas__soby-custom--ul') && (
      this.querySelectorAll('.mob-fas__soby-custom--ul li').forEach(( li_ele )=>{
        li_ele.addEventListener('click', function(){
          dropdown.classList.remove('active');
          document.querySelector('input[name="sort_by"]').value = this.dataset.value;
          document.querySelector('input[name="sort_by"]').closest('facet-filters-form').onSubmitHandler();
        })
      })
    );

    this.querySelectorAll('.list-menu__item').length && (
      this.querySelectorAll('.list-menu__item').forEach(( list_ele )=>{
        list_ele.addEventListener('click', function(){
          dropdown.classList.remove('active');
          dropdown.querySelector('.fa--cu-dd__selected-value').innerHTML = list_ele.querySelector('.facet-checkbox__label').innerText.trim();
          dropdown.querySelector('.fa--cu-dd__label').classList.add('facet_selected')
        })
      })
    )

    this.querySelector('div.facets-sorting__label') && (
      this.querySelector('div.facets-sorting__label').addEventListener('click', function(){
        if( dropdown.classList.contains('active') ){
          dropdown.classList.remove('active');
        }else{
          dropdown.classList.add('active');
        }
      }),
      this.querySelectorAll('.select__radio label').forEach(( lable_ele )=>{
        lable_ele.addEventListener('click', function(){
          if(dropdown.querySelector('.select__radio label input:checked')){
            dropdown.querySelector('.select__radio label input:checked').checked = false;
          }
          document.querySelectorAll('[name="sort_by"]').forEach((select)=>{
            if ( dropdown.querySelector('select[name="sort_by"]') != select ){
              select.value = lable_ele.querySelector('input').value;
            }
          })
          lable_ele.querySelector('input').checked = true;
          dropdown.querySelector('select[name="sort_by"]').value = lable_ele.querySelector('input').value;
          dropdown.querySelector('select[name="sort_by"]').dispatchEvent(new Event('input', { bubbles: true }))
        })
      }),
      document.addEventListener('click', (e) =>{
        const target = e.target
        if( document.querySelectorAll('custom-dropdown.active').length > 0 ){
          if( target.closest('.facets-sorting__label') != null || target.classList.contains('facets-sorting__label') ){
            return;
          }
          document.querySelectorAll('custom-dropdown.active').forEach((ele)=> ele.classList.remove('active'));
        }
      })
    );
  }
}
customElements.define('custom-dropdown', customDropdown);